







































import { defineComponent, PropType, toRef } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import useModal from "@/hooks/useModal";
import BaseIcon from "@/components/BaseIcon";
import CustomScroll from "@/components/CustomScroll";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "ModalView",
  components: { PageTitle, BaseIcon, CustomScroll },
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    title: { type: String as PropType<TranslateResult | string> },
    scrollable: { type: Boolean, default: true },
    modal: { type: Boolean, default: false },
    value: { type: Boolean, required: true },
    hideTitleIcon: { type: Boolean, default: false },
    safeMode: { type: Boolean, default: false },
    darkOverlay: { type: Boolean, default: false },
    elongated: { type: Boolean, default: false },
  },
  setup(props) {
    const { modalClose } = useModal(toRef(props, "value"), props.modal);

    return {
      modalClose,
    };
  },
});
